import styled from "styled-components";

export const CmpInfoCheckBoxLayout = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 12px;
`;

export const CmpInfoCheckBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 6px;
  border: 1px solid ${(props) => props.theme.colors.checkBoxBorder};
  border-radius: 4px;
  padding: 8px 4px;

  input {
    display: none;
  }

  p {
    white-space: nowrap;
    font-size: 1.6rem;
    font-weight: 600;
    color: ${(props) => props.theme.colors.checkBox};
  }

  &.checked {
    border: 1px solid ${(props) => props.theme.colors.primary};
    background: ${(props) => props.theme.colors.checkBoxBg};

    p {
      color: ${(props) => props.theme.colors.primary};
    }
  }
`;

export const CmpInfoCharacteristicBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border: 1px solid ${(props) => props.theme.colors.checkBoxBorder};
  border-radius: 4px;
  padding: 8px;

  p {
    white-space: nowrap;
    font-size: 1.6rem;
    font-weight: 600;
    color: ${(props) => props.theme.colors.checkBox};
  }

  &.checked {
    border: 1px solid ${(props) => props.theme.colors.primary};
    background: ${(props) => props.theme.colors.primary};

    p {
      color: ${(props) => props.theme.colors.white};
    }
  }

  &:not(.checked) {
    display: none;
  }
`;